import { hexToRgb } from './hexToRgb.ts';

export const getCellStyles = (percent: number, color: string) => {
  const rgbColor = hexToRgb(color);
  return {
    backgroundColor: `rgba(${rgbColor}, ${percent})`,
    color: percent >= 0.8 ? 'white' : 'black',
  };
};
